// extracted by mini-css-extract-plugin
var _1 = "pagination__page__mOnFd";
var _2 = "pagination__previous-page-icon__sP4fW";
export { _1 as "paginationPage", _2 as "paginationPreviousPageIcon" }
